import { render, staticRenderFns } from "./provider-update.vue?vue&type=template&id=ddce544e&"
import script from "./provider-update.vue?vue&type=script&lang=js&"
export * from "./provider-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports